var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MediaEditor',{attrs:{"id":_vm.id,"media-type":"audio","library":_vm.library}})}
var staticRenderFns = []

export { render, staticRenderFns }